<script>
export default {
  created () {
    window.location.replace('https://www.explora.com/')
  }
}
</script>
